"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classNames = require("classnames");

var React = require("react");

var close_big_svg_1 = require("svgson-loader!mrg-icons/src/mailru/actions/close_big.svg");

var close_svg_1 = require("svgson-loader!mrg-icons/src/mailru/actions/close.svg");

var baseProps_1 = require("../assets/baseProps");

var withStyles_1 = require("../decorators/withStyles");

var Panel_styles_1 = require("./Panel.styles");

var withResponsive_1 = require("../decorators/withResponsive");

var Icon_1 = require("../Icon/Icon");

var Panel =
/** @class */
function (_super) {
  __extends(Panel, _super);

  function Panel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.resizeBlock = function () {
      _this.props.onResizeHeight(_this.panel.offsetHeight);
    };

    _this.eventClickEsc = function (e) {
      if ((e.keyCode || e.which) === 27) {
        _this.props.onClose(e);
      }
    };

    _this.isClickEsc = function () {
      return _this.props.onClose && _this.props.closeByEsc;
    };

    return _this;
  }

  Panel.prototype.componentDidMount = function () {
    var onResizeHeight = this.props.onResizeHeight;

    if (onResizeHeight) {
      this.iframe.contentWindow.addEventListener('resize', this.resizeBlock);
    }

    if (this.isClickEsc()) {
      document.addEventListener('keydown', this.eventClickEsc);
    }
  };

  Panel.prototype.componentWillUnmount = function () {
    var onResizeHeight = this.props.onResizeHeight;

    if (onResizeHeight) {
      this.iframe.contentWindow.removeEventListener('resize', this.resizeBlock);
    }

    if (this.isClickEsc()) {
      document.removeEventListener('keydown', this.eventClickEsc);
    }
  };

  Panel.prototype.render = function () {
    var _a, _b;

    var _this = this;

    var props = this.props;
    var classes = props.classes,
        children = props.children,
        content = props.content,
        popup = props.popup,
        modal = props.modal,
        promo = props.promo,
        closable = props.closable,
        _c = props.size,
        size = _c === void 0 ? 'normal' : _c,
        exactSize = props["exact-size"],
        onClose = props.onClose,
        responsive = props.responsive,
        onResizeHeight = props.onResizeHeight,
        smallCross = props.smallCross,
        backgroundColor = props.backgroundColor,
        mobileCross = props.mobileCross;
    var className = classNames(classes.panel, classes[size], (_a = {}, _a[classes['exact-size']] = exactSize, _a[classes.popup] = popup, _a[classes.promo] = promo, _a[classes.mobile] = responsive === 'mobile', _a[classes.auto] = responsive === 'auto', _a));
    var closeIcon = smallCross ? close_svg_1.default : close_big_svg_1.default;
    return React.createElement("div", __assign({}, baseProps_1.default(props), {
      ref: function ref(panel) {
        return _this.panel = panel;
      },
      className: className,
      style: {
        backgroundColor: backgroundColor
      }
    }), onResizeHeight && React.createElement("iframe", {
      ref: function ref(iframe) {
        return _this.iframe = iframe;
      },
      className: classes.iframe
    }), popup && promo && React.createElement("div", {
      className: classes.plug
    }), (popup || closable) && !modal && React.createElement("div", {
      className: classNames(classes.cross, (_b = {}, _b[classes['cross-small']] = smallCross, _b[classes.mobileCross] = mobileCross, _b)),
      onClick: onClose,
      "data-test-id": "cross"
    }, React.createElement(Icon_1.default, {
      icon: closeIcon
    })), React.createElement("div", {
      className: classes.wrapper
    }, content || children));
  };

  Panel.defaultProps = {
    closeByEsc: true
  };
  Panel = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(Panel_styles_1.styles)], Panel);
  return Panel;
}(React.PureComponent);

exports.default = Panel;